import _ from 'lodash'
import Dataset from 'scoreboard/datasets/model/dataset'
const { SNAPSHOT, DATASET } = Dataset

/**
 * A function to determine if we should display the native calendar dropdown,
 * based on a metric's series. A series must have an updateType of 'manual',
 * 'calculated', 'rollup', or 'dataset' (with snapshot)
 *
 * @param {Array} seriesArr array of series belonging to a metric
 *
 */
const showNativeCalendar = (seriesArr) => {
	return _.some(seriesArr, series => {
		if (series.updateType === DATASET) {
			let datasetSeries = JSON.parse(series.equation)
			return datasetSeries.calendarFieldId == SNAPSHOT
		}
		return true
	})
}

export default showNativeCalendar
showNativeCalendar.__filename__ = 'scorecards/show-native-calendar.js'
